<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_xxii">Abbreviations</a></h1><a id="page_xxii">
<table class="abbr">
<tbody>
<tr>
<td class="w25"><p class="Abbr"><em>AASOR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Annual of the American Schools of Oriental Research</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AAWG</p></td>
<td class="w70"><p class="Abbr-h">Abhandlungen der Akademie der Wissenschaften in Göttingen</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AB</p></td>
<td class="w70"><p class="Abbr-h">Anchor Bible, ed. William F. Albright and David Noel Freedman</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ABD</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Anchor Bible Dictionary</em>, ed. David Noel Freedman. 6 vols. New York, 1992</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ABRL</p></td>
<td class="w70"><p class="Abbr-h">Anchor Bible Reference Library</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AbrN</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Abr-Nahrain</em> (continued by <em>Ancient Near Eastern Studies</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AcOr</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Acta orientalia</em> (Copenhagen)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AcSu</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Acta sumerologica</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AfO</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Archiv für Orientforschung</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AfOB</p></td>
<td class="w70"><p class="Abbr-h">Archiv für Orientforschung: Beiheft</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AGSJU</p></td>
<td class="w70"><p class="Abbr-h">Arbeiten zur Geschichte des Spätjudentums und Urchristentums</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AHw</p></td>
<td class="w70"><p class="Abbr-h">Wolfram von Soden, <em>Akkadisches Handwörterbuch</em>. 3 vols. Wiesbaden, 1959–81.</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AJBI</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Annual of the Japanese Biblical Institute</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AJP</em></p></td>
<td class="w70"><p class="Abbr-h"><em>American Journal of Philology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AJSL</em></p></td>
<td class="w70"><p class="Abbr-h"><em>American Journal of Semitic Languages and Literatures</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AJSR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Association for Jewish Studies Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AJT</em></p></td>
<td class="w70"><p class="Abbr-h"><em>American Journal of Theology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Akk</p></td>
<td class="w70"><p class="Abbr-h">Akkadian</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Al.T</p></td>
<td class="w70"><p class="Abbr-h">Donald J. Wiseman, <em>The Alalakh Tablets</em>. London, 1953</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AmT</p></td>
<td class="w70"><p class="Abbr-h">The Bible: An American Translation, trans. J. M. Powis Smith and Edgar J. Goodspeed. Chicago, 1935</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AnBib</p></td>
<td class="w70"><p class="Abbr-h">Analecta biblica</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ANE</p></td>
<td class="w70"><p class="Abbr-h">Ancient Near East(ern)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ANEP</em><sup>2</sup></p></td>
<td class="w70"><p class="Abbr-h"><em>The Ancient Near East in Pictures</em>, ed. James B. Pritchard. 2nd ed. with Supplement. Princeton, 1969</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxiii"><em>ANET</em><sup>3</sup></a></p></td>
<td class="w70"><p class="Abbr-h"><em>Ancient Near Eastern Texts Relating to the Old Testament</em>, ed. James B. Pritchard. 3rd ed. with Supplement. Princeton, 1969</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AnOr</p></td>
<td class="w70"><p class="Abbr-h">Analecta Orientalia</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AOAT</p></td>
<td class="w70"><p class="Abbr-h">Alter Orient und Altes Testament</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AOS</p></td>
<td class="w70"><p class="Abbr-h">American Oriental Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>APOT</em></p></td>
<td class="w70"><p class="Abbr-h"><em>The Apocrypha and Pseudepigrapha of the Old Testament</em>, ed. R. H. Charles. 2 vols. Oxford, 1913</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ApOTC</p></td>
<td class="w70"><p class="Abbr-h">Apollos Old Testament Commentary</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Aq</p></td>
<td class="w70"><p class="Abbr-h">Aquila</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Ar</p></td>
<td class="w70"><p class="Abbr-h">Arabic</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ArBib</p></td>
<td class="w70"><p class="Abbr-h">The Aramaic Bible</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ARM</p></td>
<td class="w70"><p class="Abbr-h">Archives royales de Mari</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ArOr</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Archiv Orientální</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AS</p></td>
<td class="w70"><p class="Abbr-h">Assyriological Studies</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ASOR</p></td>
<td class="w70"><p class="Abbr-h">American Schools of Oriental Research</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ATANT</p></td>
<td class="w70"><p class="Abbr-h">Abhandlungen zur Theologie des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ATR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Anglican Theological Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AuOr</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Aula orientalis</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>AUSS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Andrews University Seminary Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">AV</p></td>
<td class="w70"><p class="Abbr-h">Authorized King James Version, 1611</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>b</em>.</p></td>
<td class="w70"><p class="Abbr-h">Babylonian Talmud</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblical Archaeologist</em> (continued as <em>NEA</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BAR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblical Archaeology Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BASOR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Bulletin of the American Schools of Oriental Research</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BASORSup</p></td>
<td class="w70"><p class="Abbr-h">Bulletin of the American Schools of Oriental Research: Supplement Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BBVO</p></td>
<td class="w70"><p class="Abbr-h">Berliner Beiträge zum Vorderen Orient</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BDB</p></td>
<td class="w70"><p class="Abbr-h"><em>A Hebrew and English Lexicon of the Old Testament</em>, ed. Francis Brown, S. R. Driver, and Charles A. Briggs. Oxford, 1907</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BETL</p></td>
<td class="w70"><p class="Abbr-h">Bibliotheca ephemeridum theologicarum lovaniensium</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BH</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblia Hebraica</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BH</em><sup>1</sup></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblia Hebraica</em>. 1st ed., ed. Rudolf Kittel. Stuttgart, 1905–6</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BH</em><sup>3</sup></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblia Hebraica</em>. 3rd ed., ed. Rudolf Kittel. Stuttgart, 1937</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BHM</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Bulletin of the History of Medicine</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BHQ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblia Hebraica Quinta</em>. 5th ed., ed. Adrian Schenker et al. Stuttgart, 1998–</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BHS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblia Hebraica Stuttgartensia</em>, ed. Kurt Elliger and Wilhelm Rudolph. Stuttgart, 1983. <em>Liber Jeremiae</em> prepared by Wilhelm Rudolph. Stuttgart, 1970</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BHT</p></td>
<td class="w70"><p class="Abbr-h">Beiträge zur historischen Theologie</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Bib</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BibOr</p></td>
<td class="w70"><p class="Abbr-h">Biblica et orientalia</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BIW</p></td>
<td class="w70"><p class="Abbr-h">The Bible in Its World</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxiv"><em>BJRL</em></a></p></td>
<td class="w70"><p class="Abbr-h"><em>Bulletin of the John Rylands Library</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BJS</p></td>
<td class="w70"><p class="Abbr-h">Brown Judaic Studies</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BN</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblische Notizen</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BRev</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Bible Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BRS</p></td>
<td class="w70"><p class="Abbr-h">Biblical Resource Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BW</em></p></td>
<td class="w70"><p class="Abbr-h"><em>The Biblical World</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BWANT</p></td>
<td class="w70"><p class="Abbr-h">Beiträge zur Wissenschaft vom Alten und Neuen Testament</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>BZ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Biblische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">BZAW</p></td>
<td class="w70"><p class="Abbr-h">Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CAD</em></p></td>
<td class="w70"><p class="Abbr-h"><em>The Assyrian Dictionary of the Oriental Institute of the University of Chicago</em>, ed. Ignace J. Gelb et al. Chicago, 1956–</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CB</p></td>
<td class="w70"><p class="Abbr-h">Century Bible, ed. Walter F. Adeney</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CBC</p></td>
<td class="w70"><p class="Abbr-h">Cambridge Bible Commentary</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CBQ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CBSC</p></td>
<td class="w70"><p class="Abbr-h">Cambridge Bible for Schools and Colleges. OT ed. Alexander Francis Kirkpatrick</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CD</p></td>
<td class="w70"><p class="Abbr-h">Cairo Genizah copy of the <em>Damascus Document</em> (= “Zadokite” Document)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CH</p></td>
<td class="w70"><p class="Abbr-h">Code of Hammurabi</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CIS</p></td>
<td class="w70"><p class="Abbr-h"><em>Corpus inscriptionum semiticarum</em> (Paris)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ConBOT</p></td>
<td class="w70"><p class="Abbr-h">Coniectanea biblica: Old Testament Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>COS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>The Context of Scripture</em>, ed. William W. Hallo. 3 vols. Leiden, 1997–2003</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CovH</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Covenant Hymnal</em>. Chicago, 1950</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CovQ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Covenant Quarterly</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CP</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Classical Philology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CPSSup</p></td>
<td class="w70"><p class="Abbr-h">Cambridge Philological Society: Supplementary Volumes</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CQ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Classical Quarterly</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CRFB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Christian Rural Fellowship Bulletin</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">CUF</p></td>
<td class="w70"><p class="Abbr-h">Collection des Universités de France</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>CurTM</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Currents in Theology and Mission</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">D</p></td>
<td class="w70"><p class="Abbr-h">Deuteronomic source of the Pentateuch</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>DDD</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Dictionary of Deities and Demons in the Bible</em>, ed. Karel van der Toorn, Bob Becking, and Pieter W. van der Horst. Leiden and Grand Rapids, 1999</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">DH</p></td>
<td class="w70"><p class="Abbr-h">Deuteronomic Historian</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Dict Talm</em></p></td>
<td class="w70"><p class="Abbr-h"><em>A Dictionary of the Targumim, the Talmud Babli and Yerushalmi, and the Midrashic Literature</em>, ed. Marcus Jastrow. 2 vols. London, 1903; Peabody, 2005</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Did</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Didache</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">DJD</p></td>
<td class="w70"><p class="Abbr-h">Discoveries in the Judaean Desert</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>DMB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Danish Medical Bulletin</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">DMOA</p></td>
<td class="w70"><p class="Abbr-h">Documenta et monumenta Orientis antiqui</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxv"><em>DSD</em></a></p></td>
<td class="w70"><p class="Abbr-h"><em>Dead Sea Discoveries</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">E</p></td>
<td class="w70"><p class="Abbr-h">Elohist source of the Pentateuch</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">EA</p></td>
<td class="w70"><p class="Abbr-h">El-Amarna tablets. According to the edition of J. A. Knudtzon, <em>Die el-Amarna-Tafeln</em>. Leipzig, 1908–15. Repr. Aalen, 1964. Continued in A. F. Rainey, <em>El-Amarna Tablets, 359–79</em>. 2nd rev. ed. Kevelaer, 1978.</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">EBib</p></td>
<td class="w70"><p class="Abbr-h">Etudes bibliques</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ECB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Eerdmans Commentary on the Bible</em>, ed. James D. G. Dunn and John W. Rogerson. Grand Rapids, 2003</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>EDSS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Encyclopedia of the Dead Sea Scrolls</em>, ed. Lawrence H. Schiffman and James C. VanderKam. 2 vols. Oxford, 2000</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>EncB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Encyclopaedia Britannica</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>EncIs</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Encyclopaedia of Islam</em>. New (2nd) ed., ed. C. E. Bosworth et al. Leiden, 1960–</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>EncJud</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Encyclopaedia Judaica</em>, ed. Cecil Roth and Geoffrey Wigoder. 18 vols. Jerusalem, 1982–92</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ErIsr</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Eretz-Israel</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>EstBib</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Estudios bíblicos</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ETL</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Ephemerides theologicae lovanienses</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">EVV</p></td>
<td class="w70"><p class="Abbr-h">Modern English Versions of the Bible</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ExpTim</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">FRCS</p></td>
<td class="w70"><p class="Abbr-h">Folklore Research Center Studies</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">FRLANT</p></td>
<td class="w70"><p class="Abbr-h">Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">FS</p></td>
<td class="w70"><p class="Abbr-h">Festschrift</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">G<sup>B</sup></p></td>
<td class="w70"><p class="Abbr-h">Codex Vaticanus</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Gk</p></td>
<td class="w70"><p class="Abbr-h">Greek</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">GKC</p></td>
<td class="w70"><p class="Abbr-h"><em>Gesenius’ Hebrew Grammar</em>, ed. E. Kautzsch; trans. A. E. Cowley. 2nd ed. Oxford, 1963. Orig. 1910</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">GNB</p></td>
<td class="w70"><p class="Abbr-h">Good News Bible (New York, 1976)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>GRBS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Greek, Roman and Byzantine Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">GTA</p></td>
<td class="w70"><p class="Abbr-h">Göttinger theologische Arbeiten</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">H</p></td>
<td class="w70"><p class="Abbr-h">Holiness Code in Leviticus 17–26</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>HAR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Hebrew Annual Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>HDB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>A Dictionary of the Bible</em>, ed. James Hastings. New York, 1902</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Heb</p></td>
<td class="w70"><p class="Abbr-h">Hebrew</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Hen</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Henoch</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Hist. eccl.</em></p></td>
<td class="w70"><p class="Abbr-h">Eusebius, <em>Ecclesiastical</em> History</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">HL</p></td>
<td class="w70"><p class="Abbr-h">Hittite Laws</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>HS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Hebrew Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">HSM</p></td>
<td class="w70"><p class="Abbr-h">Harvard Semitic Monographs</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">HSS</p></td>
<td class="w70"><p class="Abbr-h">Harvard Semitic Studies</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>HTR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxvi"><em>HUB</em></a></p></td>
<td class="w70"><p class="Abbr-h"><em>Hebrew University Bible</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>HUCA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Hebrew Union College Annual</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>IB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Interpreter’s Bible</em>, ed. George A. Buttrick. 12 vols. New York, 1951–57</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ICC</p></td>
<td class="w70"><p class="Abbr-h">International Critical Commentary, ed. S. R. Driver, Alfred Plummer, and Charles A. Briggs</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>IDB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Interpreter’s Dictionary of the Bible</em>, ed. George A. Buttrick. 4 vols. New York, 1962</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>IDBSup</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Interpreter’s Dictionary of the Bible, Supplementary Volume</em>, ed. Keith Crimm. Nashville, 1976</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>IEJ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Israel Exploration Journal</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Int</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Interpretation</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>IOS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Israel Oriental Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>IR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Iliff Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">J</p></td>
<td class="w70"><p class="Abbr-h">Yahwist source of the Pentateuch</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JANES</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of the Ancient Near Eastern Society of Columbia University</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JAOS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of the American Oriental Society</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">JB</p></td>
<td class="w70"><p class="Abbr-h">Jerusalem Bible</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JBL</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JBW</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Jahrbücher der biblischen Wissenschaft</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JCS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Cuneiform Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JE</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Jewish Encyclopedia</em>, ed. Cyrus Adler et al. 12 vols. New York, 1901–6</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">JE</p></td>
<td class="w70"><p class="Abbr-h">Combined Yahwistic and Elohistic sources of the Pentateuch</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JEA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Egyptian Archaeology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JEOL</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Jaarbericht van het Vooraziatisch-Egyptisch Genootschap “Ex oriente lux”</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JHI</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of the History of Ideas</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JJS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Jewish Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JLA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Jewish Law Annual</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JNES</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Near Eastern Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JNSL</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Northwest Semitic Languages</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JP</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Philology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JPOS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of the Palestine Oriental Society</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">JPS</p></td>
<td class="w70"><p class="Abbr-h">Jewish Publication Society</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JQR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Jewish Quarterly Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JRev</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Juridical Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JSOT</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal for the Study of the Old Testament</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">JSOTSup</p></td>
<td class="w70"><p class="Abbr-h">Journal for the Study of the Old Testament: Supplement Series (Continued as LHB/OTS)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JSS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Semitic Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>JTS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Jub.</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Jubilees</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">K</p></td>
<td class="w70"><p class="Abbr-h">Kethib (“what is written”)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxvii">KAI</a></p></td>
<td class="w70"><p class="Abbr-h"><em>Kanaanäische und aramäische Inschriften</em>. 2nd ed., ed. Herbert Donner and Wolfgang Röllig. 3 vols. Wiesbaden, 1962–71</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">KBL<sup>3</sup></p></td>
<td class="w70"><p class="Abbr-h">Ludwig Köhler and Walter Baumgartner, <em>Hebräisches und Aramäisches Lexikon zum Alten Testament</em>. 3rd ed. Leiden, 1967–90</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">KEH</p></td>
<td class="w70"><p class="Abbr-h">Kurzgefasstes exegetisches Handbuch zum Alten Testament</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">KRT</p></td>
<td class="w70"><p class="Abbr-h"><em>La Légende de Keret</em>, C. Virolleaud. Paris, 1936; H. L. Ginsberg, <em>BASORSup</em> 2–3, 1946</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">KTU</p></td>
<td class="w70"><p class="Abbr-h"><em>Die keilalphabetischen Texte aus Ugarit</em>, ed. Manfred Dietrich, Oswald Loretz, and Joaquin Sanmartín. AOAT 24. Neukirchen, 1976</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Lane</p></td>
<td class="w70"><p class="Abbr-h">E. W. Lane, <em>An Arabic-English Lexicon</em>. London 1863–93</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Lat</p></td>
<td class="w70"><p class="Abbr-h">Latin</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">LCL</p></td>
<td class="w70"><p class="Abbr-h">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">LE</p></td>
<td class="w70"><p class="Abbr-h">Laws of Eshnunna</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">LHB/OTS</p></td>
<td class="w70"><p class="Abbr-h">Library of Hebrew Bible/Old Testament Studies (continuing JSOTSup)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">LI</p></td>
<td class="w70"><p class="Abbr-h">Laws of Lipit-Ištar</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Liv. Pro.</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Lives of the Prophets</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Loeb</p></td>
<td class="w70"><p class="Abbr-h">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">LOS</p></td>
<td class="w70"><p class="Abbr-h">London Oriental Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">LUN</p></td>
<td class="w70"><p class="Abbr-h">Laws of Ur-Nammu</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">LXX</p></td>
<td class="w70"><p class="Abbr-h">Septuagint, according to <em>Septuaginta II</em>. 8th ed., ed. Alfred Rahlfs. Stuttgart, 1965</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">M<sup>A</sup></p></td>
<td class="w70"><p class="Abbr-h">Masoretic Text according to the Aleppo Codex (Codex A)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">M<sup>L</sup></p></td>
<td class="w70"><p class="Abbr-h">Masoretic Text according to the Leningrad Codex B19<sup>A</sup> (Codex L)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">MAL</p></td>
<td class="w70"><p class="Abbr-h">Middle Assyrian Laws</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Mandelkern</p></td>
<td class="w70"><p class="Abbr-h">Solomon Mandelkern, <em>Veteris Testamenti Concordantiae</em>. Tel Aviv, 1964</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Mart. Isa.</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Martyrdom of Isaiah</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">MS(S)</p></td>
<td class="w70"><p class="Abbr-h">Manuscript(s)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">MSU</p></td>
<td class="w70"><p class="Abbr-h">Mitteilungen des Septuaginta-Unternehmens</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">MT</p></td>
<td class="w70"><p class="Abbr-h">Masoretic Text, according to <em>BH</em><sup>3</sup> or <em>BHS</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NAB</p></td>
<td class="w70"><p class="Abbr-h">New American Bible</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NCBC</p></td>
<td class="w70"><p class="Abbr-h">New Century Bible Commentary</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>NEA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Near Eastern Archaeology</em> (continuing <em>BA</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>NEAEHL</em></p></td>
<td class="w70"><p class="Abbr-h"><em>New Encyclopedia of Archaeological Excavations in the Holy Land</em>, ed. Ephraim Stern. 4 vols. Jerusalem, 1993</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NEB</p></td>
<td class="w70"><p class="Abbr-h">New English Bible</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NEcB</p></td>
<td class="w70"><p class="Abbr-h">Die Neue Echter Bibel</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NIV</p></td>
<td class="w70"><p class="Abbr-h">New International Version</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NJB</p></td>
<td class="w70"><p class="Abbr-h">New Jerusalem Bible</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxviii">NJV</a></p></td>
<td class="w70"><p class="Abbr-h">Tanakh: A New Translation of the Holy Scriptures According to the Traditional Hebrew Text. Philadelphia, 1985</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>NKZ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Neue kirchliche Zeitschrift</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NRSV</p></td>
<td class="w70"><p class="Abbr-h">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">NT</p></td>
<td class="w70"><p class="Abbr-h">New Testament</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">OBO</p></td>
<td class="w70"><p class="Abbr-h">Orbis biblicus et orientalis</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>OEANE</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Oxford Encyclopedia of Archaeology in the Near East</em>, ed. Eric M. Meyers. 5 vols. Oxford, 1997</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>OED</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Oxford English Dictionary</em>. 2nd ed. Oxford, 1989</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">OIP</p></td>
<td class="w70"><p class="Abbr-h">Oriental Institute Publications. University of Chicago</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>OJA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Oxford Journal of Archaeology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Onom.</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Onomasticon</em> of Eusebius</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Or</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Orientalia</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>OrAnt</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Oriens antiquus</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">OT</p></td>
<td class="w70"><p class="Abbr-h">Old Testament</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">OTL</p></td>
<td class="w70"><p class="Abbr-h">Old Testament Library</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>OTP</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Old Testament Pseudepigrapha</em>, ed. James H. Charlesworth. 2 vols. Garden City, 1983–85</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">OTS</p></td>
<td class="w70"><p class="Abbr-h">Oudtestamentische Studiën</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">OTWSA</p></td>
<td class="w70"><p class="Abbr-h">Die Oudtestamentiese Werkgemeenskap in Suid-Afrika</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">P</p></td>
<td class="w70"><p class="Abbr-h">“Priestly” source of the Pentateuch</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">PEFQS</p></td>
<td class="w70"><p class="Abbr-h"><em>Palestine Exploration Fund. Quarterly Statement (continued as Palestine Exploration Quarterly</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>PEQ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Palestine Exploration Quarterly (continuing Palestine Exploration Fund. Quarterly Statement</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>PIBA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Proceedings of the Irish Biblical Association</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">POS</p></td>
<td class="w70"><p class="Abbr-h">Pretoria Oriental Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">PRU</p></td>
<td class="w70"><p class="Abbr-h">Le Palais Royal d’Ugarit, ed. Claude F.-A. Schaeffer</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>PSBA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Proceedings of the Society of Biblical Archaeology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Q</p></td>
<td class="w70"><p class="Abbr-h">Qere (“what is read”)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">QT</p></td>
<td class="w70"><p class="Abbr-h">Qumran <em>Temple Scroll</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>RA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Revue d’Assyriologie et d’Archéologie Orientale</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>RB</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Revue biblique</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">REB</p></td>
<td class="w70"><p class="Abbr-h">Revised English Bible</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>RES</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Revue des études sémitiques</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>RevQ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Revue de Qumrân</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">RGG<sup>1</sup></p></td>
<td class="w70"><p class="Abbr-h">Die Religion in Geschichte und Gegenwart, 1st ed. Tübingen, 1909–13</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>RHA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Revue hittite et asianique</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>RIDA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Revue internationale des droits de l’antiquité</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>RLA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Reallexikon der Assyriologie</em>, ed. Erich Ebeling und Bruno Meissner. Berlin, 1932–</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">RSV</p></td>
<td class="w70"><p class="Abbr-h">Revised Standard Version</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxix">RV</a></p></td>
<td class="w70"><p class="Abbr-h">Revised Version</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">S</p></td>
<td class="w70"><p class="Abbr-h">Syriac</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SAA</p></td>
<td class="w70"><p class="Abbr-h">State Archives of Assyria</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Sam</p></td>
<td class="w70"><p class="Abbr-h">Samaritan Pentateuch</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SAOC</p></td>
<td class="w70"><p class="Abbr-h">Studies in Ancient Oriental Civilization</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBAB</p></td>
<td class="w70"><p class="Abbr-h">Stuttgarter biblische Aufsatzbände</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBL</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBLABS</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature Archaeology and Biblical Studies</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBLDS</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBLMS</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature Monograph Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBLSCSS</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature Septuagint and Cognate Studies Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBLSymS</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature Symposium Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBLTT</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature Texts and Translations</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBLWAW</p></td>
<td class="w70"><p class="Abbr-h">Society of Biblical Literature Writings from the Ancient World</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBS</p></td>
<td class="w70"><p class="Abbr-h">Stuttgarter Bibelstudien</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SBT</p></td>
<td class="w70"><p class="Abbr-h">Studies in Biblical Theology</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">ScrHier</p></td>
<td class="w70"><p class="Abbr-h">Scripta hierosolymitana</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Sem</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Semitica</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SHANE</p></td>
<td class="w70"><p class="Abbr-h">Studies in the History of the Ancient Near East</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Sib. Or.</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Sibylline Oracles</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>Sit.</em></p></td>
<td class="w70"><p class="Abbr-h">Jerome, <em>De situ et nominibus locorum Hebraicorum (Liber locorum)</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">SJLA</p></td>
<td class="w70"><p class="Abbr-h">Studies in Judaism in Late Antiquity</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>SJOT</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Scandinavian Journal of the Old Testament</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>SJT</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>SLR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Stanford Law Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>SRR</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Seminary Ridge Review</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">STDJ</p></td>
<td class="w70"><p class="Abbr-h">Studies on the Texts of the Desert of Judah</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">StPB</p></td>
<td class="w70"><p class="Abbr-h">Studia post-biblica</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Symm</p></td>
<td class="w70"><p class="Abbr-h">Symmachus</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">T</p></td>
<td class="w70"><p class="Abbr-h">Targum(s)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">T<sup>MS</sup></p></td>
<td class="w70"><p class="Abbr-h">Targum Manuscript</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">T<sup>Nf</sup></p></td>
<td class="w70"><p class="Abbr-h">Targum Neofiti</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">T<sup>Onq</sup></p></td>
<td class="w70"><p class="Abbr-h">Targum Onqelos</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">T<sup>PsJ</sup></p></td>
<td class="w70"><p class="Abbr-h">Targum Pseudo-Jonathan</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>T. Levi</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Testament of Levi</em> (in <em>The Testament of the Twelve Patriarchs</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>T. Reu.</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Testament of Reuben</em> (in <em>The Testament of the Twelve Patriarchs</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>T. Sim.</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Testament of Simeon</em> (in <em>The Testament of the Twelve Patriarchs</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>TA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Tel Aviv</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>TAPS</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Transactions of the American Philosophical Society</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">TB</p></td>
<td class="w70"><p class="Abbr-h">Theologische Bücherei</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>TDOT</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Theological Dictionary of the Old Testament</em>, ed. G. Johannes Botterweck, Helmer Ringgren, and Heinz-Josef Fabry. 17 vols. Grand Rapids, 1974–</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><a id="page_xxx"><em>Text</em></a></p></td>
<td class="w70"><p class="Abbr-h"><em>Textus</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Theod</p></td>
<td class="w70"><p class="Abbr-h">Theodotion</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>TLZ</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Theologische Literaturzeitung</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>TRE</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Theologische Realenzyklopädie</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>UF</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Ugarit-Forschungen</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Ug</p></td>
<td class="w70"><p class="Abbr-h">Ugaritic</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">UgT</p></td>
<td class="w70"><p class="Abbr-h">Ugaritic text</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>UM</em></p></td>
<td class="w70"><p class="Abbr-h">Cyrus H. Gordon, <em>Ugaritic Manual</em>. AnOr 35. Rome, 1955</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>UT</em></p></td>
<td class="w70"><p class="Abbr-h">Cyrus H. Gordon, <em>Ugaritic Textbook</em>. AnOr 38. Rome, 1965</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">VAT</p></td>
<td class="w70"><p class="Abbr-h">Vorderasiatische Abteilung Tontafel. Vorderasiatisches Museum, Berlin</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">Vg</p></td>
<td class="w70"><p class="Abbr-h">Vulgate</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>VT</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Vetus Testamentum</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>VTE</em></p></td>
<td class="w70"><p class="Abbr-h">D. J. Wiseman, <em>Vassal Treaties of Esarhaddon. Iraq</em> 20 (1958) 1–99; also London, 1958</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">VTSup</p></td>
<td class="w70"><p class="Abbr-h">Supplements to Vetus Testamentum</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">War Scroll</p></td>
<td class="w70"><p class="Abbr-h"><em>Scroll of the War of the Sons of Light against the Sons of Darkness</em> (1QM)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>WHJP</em></p></td>
<td class="w70"><p class="Abbr-h"><em>World History of the Jewish People</em>. 1st ser.: <em>Ancient Times</em>, ed. E. A. Speiser et al. Jerusalem, 1964–79</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>WW</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Western Watch</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr">YJS</p></td>
<td class="w70"><p class="Abbr-h">Yale Judaica Series</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ZA</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Zeitschrift für Assyriologie und verwandte Gebiete</em> (continued as <em>Zeitschrift für Assyriologie und vorderasiatische Archäologie</em>)</p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ZAW</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Zeitschrift für die alttestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ZDMG</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Zeitschrift der deutschen morgenländischen Gesellschaft</em></p></td>
</tr>
<tr>
<td class="w25"><p class="Abbr"><em>ZDPV</em></p></td>
<td class="w70"><p class="Abbr-h"><em>Zeitschrift des deutschen Palästina-Vereins</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?6ba1489d